import { useUpdateIglooWorksConnection } from '@/api/property-keyless/igloo-works/update-igloo-works-connection'

import { IglooWorksConnectionFormValues } from './igloo-works.schema'

const parseJsonRecord = (value: string): Record<string, string> =>
  value ? (JSON.parse(value) as Record<string, string>) : {}

export const useIglooWorksSubmit = (buildingId: number) => {
  const { mutateAsync, isPending } = useUpdateIglooWorksConnection()

  const submit = (values: IglooWorksConnectionFormValues) =>
    mutateAsync({
      buildingId,
      clientId: values.clientId,
      clientSecret: values.clientSecret,
      config: {
        permissionDoors: parseJsonRecord(values.permissionDoors),
        shouldAutoAssignApartmentDoor: values.shouldAutoAssignApartmentDoor,
        shouldAutoAssignApartmentDoorVisitor: values.shouldAutoAssignApartmentDoorVisitor,
        visitorPermissionDoors: parseJsonRecord(values.visitorPermissionDoors),
      },
    })

  return { isPending, submit }
}
